import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <button 
      onClick={toggleTheme}
      className="nav-button"
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: 'var(--spacing-md) var(--spacing-lg)',
        margin: 'var(--spacing-xs) var(--spacing-sm) var(--spacing-xs) calc(var(--spacing-sm) + 10px)',
        borderRadius: 'var(--radius-md)',
        color: 'var(--text-light)',
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        backgroundColor: 'transparent',
        border: 'none',
        width: '100%',
        textAlign: 'left',
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',
        transform: 'scale(1)'
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = 'var(--medium-gray)'
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = 'transparent'
      }}
      onFocus={(e) => {
        e.target.style.backgroundColor = 'var(--medium-gray)'
      }}
      onBlur={(e) => {
        e.target.style.backgroundColor = 'transparent'
      }}
      onTouchStart={(e) => {
        e.preventDefault()
        e.target.style.backgroundColor = 'var(--medium-gray)'
        e.target.style.transform = 'scale(0.98)'
      }}
      onTouchEnd={(e) => {
        setTimeout(() => {
          e.target.style.backgroundColor = 'transparent'
          e.target.style.transform = 'scale(1)'
        }, 150)
      }}
      onTouchCancel={(e) => {
        e.target.style.backgroundColor = 'transparent'
        e.target.style.transform = 'scale(1)'
      }}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} theme`}
      title={`Switch to ${isDark ? 'light' : 'dark'} theme`}
    >
      <div 
        className="theme-toggle-track"
        style={{
          position: 'relative',
          width: '48px',
          height: '24px',
          background: 'var(--bg-quaternary)',
          borderRadius: '12px',
          border: '1px solid var(--border-color)',
          transition: 'all var(--transition-normal)',
          overflow: 'hidden',
          cursor: 'pointer',
          userSelect: 'none'
        }}
      >
        <div className={`theme-toggle-thumb ${isDark ? 'dark' : 'light'}`}>
          <div className="theme-icon">
            {isDark ? (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" fill="currentColor"/>
              </svg>
            ) : (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="5" fill="currentColor"/>
                <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            )}
          </div>
        </div>
      </div>
      <span style={{
        fontSize: 'var(--text-sm)',
        fontWeight: '400',
        marginLeft: 'var(--spacing-md)'
      }}>
        {isDark ? 'Dark' : 'Light'}
      </span>
    </button>
  );
};

export default ThemeToggle;
